import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

const UserMenu = ({ 
    isOpen, 
    userEmail, 
    onUpgrade, 
    onLogout 
}) => {
    const { t } = useTranslation();

    const handleUpgrade = useCallback((e) => {
        e.stopPropagation();
        onUpgrade();
    }, [onUpgrade]);

    const handleLogout = useCallback((e) => {
        e.stopPropagation();
        onLogout();
    }, [onLogout]);

    if (!isOpen) return null;

    return (
        <div 
            className="user-menu-popup" 
            onClick={(e) => e.stopPropagation()}
            role="menu"
            aria-label="User menu"
        >
            <button 
                className="user-menu-item disabled" 
                disabled
                aria-disabled="true"
            >
                <i className="bi bi-envelope-at"> </i>
                {userEmail || t('chat.sidebar_loading', 'loading...')}
            </button>

            <div className="user-menu-separator" role="separator" />
            
            <button 
                className="user-menu-item" 
                onClick={handleUpgrade}
                role="menuitem"
            >
                <i className="bi bi-arrow-up-square"> </i>
                {t('chat.sidebar_upgrade', 'Upgrade')}
            </button>

            <div className="user-menu-separator" role="separator" />

            <button 
                className="user-menu-item logout" 
                onClick={handleLogout}
                role="menuitem"
            >
                <i className="bi bi-box-arrow-right"> </i>
                {t('chat.sidebar_logout', 'Logout')}
            </button>
        </div>
    );
};

export default React.memo(UserMenu);